// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__League_Spartan_1e6ae6', '__League_Spartan_Fallback_1e6ae6'","fontStyle":"normal"},"className":"__className_1e6ae6","variable":"__variable_1e6ae6"};